var _svg;
import React from "react";
const QualityReview = ({
  ...rest
}) => {
  return _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
    width: "50",
    height: "50",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "22",
    fill: "#FFE899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3793 23.3696C25.9318 22.521 26.9977 20.8936 26.9999 19C26.9999 16.2386 24.7613 14 21.9999 14C19.2385 14 16.9999 16.2386 16.9999 19C16.9999 20.8936 18.0649 22.5214 19.617 23.3701C16.5582 24.3276 14.2491 27.0767 14.0263 30.4668C14.0261 30.4695 14.0259 30.4722 14.0258 30.4749C14.0097 30.7507 14.2202 30.9872 14.4959 31.0034C14.7717 31.0194 15.0082 30.809 15.0243 30.5332C15.2539 27.0328 18.0421 24.2445 21.5425 24.015C25.395 23.7624 28.7229 26.6807 28.9755 30.5332C28.9932 30.7958 29.2113 30.9998 29.4745 31C29.4852 31 29.496 31 29.5078 30.999C29.7833 30.9805 29.9918 30.7424 29.9736 30.4668C29.753 27.1099 27.4706 24.3337 24.3793 23.3696ZM21.9999 23C19.7907 23 17.9999 21.2092 17.9999 19C17.9999 16.7908 19.7907 15 21.9999 15C24.2081 15.0024 25.9975 16.7918 25.9999 19C25.9999 21.2092 24.2091 23 21.9999 23ZM33.3533 19.9866C33.16 19.7894 32.8435 19.7863 32.6463 19.9796L30.3328 22.293L29.3533 21.3135C29.1589 21.123 28.8479 21.123 28.6535 21.3135C28.4563 21.5068 28.4531 21.8233 28.6464 22.0205L29.9794 23.3535C30.073 23.4474 30.2003 23.5002 30.3329 23.5C30.4655 23.5001 30.5927 23.4474 30.6863 23.3535L33.3533 20.6865C33.5438 20.4921 33.5438 20.181 33.3533 19.9866Z",
    fill: "black",
    "fill-opacity": "0.87"
  })));
};
export default QualityReview;